import type Timeline from '@mimir/client-common/timeline/Timeline';
import type { LoadedItem } from '@mimir/common/dto/searchResultHit';
import { SystemDefaultField } from '@mimir/common/mdf/mdfDefaults';
import { getItemSystemDefaultField } from '@mimir/common/mdf/MetaDataForm';
import type TimedTranscript from '@mimir/common/transcript/timedTranscript';
import { getFirstAndLastWordsFromTimeRange } from '@mimir/common/transcript/transcriptParagraph';
import { millisecondsToHumanReadableTime } from '@mimir/common/util/date';
import type { FuzzyValue } from '@mimir/common/util/fuzzyNumbers';

export function getTitleBasedOnRange(
  currentItem: LoadedItem | null,
  timeline: Timeline,
  virtualClipStart: FuzzyValue | null,
  durationInMs: number,
  isGrowing: boolean,
): string {
  if (currentItem === null)
    return '';

  const itemTitle = getItemSystemDefaultField(currentItem, SystemDefaultField.Title);
  if (timeline === null || !timeline.hasMarks)
    return itemTitle;

  const timedTranscript = currentItem.timedTranscript as TimedTranscript;
  const markIn = timeline.getMarkIn(virtualClipStart);
  const markOut = timeline.getMarkOut(durationInMs, virtualClipStart);
  if (timedTranscript) {
    const result =
      getFirstAndLastWordsFromTimeRange({
        start: markIn, end: markOut}, timedTranscript.getActiveParagraphs(markIn, markOut));
    if (result) {
      return `${result.firstWord.content}...${isGrowing ? '' : result.lastWord.content}`;
    }
  }
  // We got no valid words from transcript - fall back on range based.
  const rangeBasedTitle = `${millisecondsToHumanReadableTime(markIn)} - ${isGrowing ? '' : millisecondsToHumanReadableTime(markOut)}`;
  return `${rangeBasedTitle}_${itemTitle}`;
}
